import { GenericAbortSignal } from 'axios';

import {
  TimeseriesApiResponse,
  ModalityRadarApiResponse,
  PreciseHeatmapApiResponse,
  TimeseriesParams,
  HeatmapSubcategoriesResponse,
  CategoryCountryResponse,
} from '@/features/Analytics/interfaces';

import { request } from '@/utils/request';

export const makeApi = (instance = request) => ({
  getTimeseries: (focusId: number, params: TimeseriesParams, signal?: GenericAbortSignal) =>
    instance.get<TimeseriesApiResponse>(`analytics/focus/${focusId}/timeseries/`, {
      params,
      skipCaseConversion: true,
      signal,
    }),

  getModalityRadar: (focusId: number, signal?: GenericAbortSignal) =>
    instance.get<ModalityRadarApiResponse>(`analytics/focus/${focusId}/modality-radar/`, {
      params: { top_n: 10 },
      skipCaseConversion: true,
      signal,
    }),

  getPreciseHeatmap: (focusId: number, subCategoryId: number, signal?: GenericAbortSignal) =>
    instance.get<PreciseHeatmapApiResponse>(
      `analytics/focus/${focusId}/event-time/precise-heatmap/`,
      {
        params: { 'sub-category-id': subCategoryId },
        skipCaseConversion: true,
        signal,
      }
    ),

  getVolumeByCountry: (focusId: number, params: TimeseriesParams, signal?: GenericAbortSignal) =>
    instance.get<TimeseriesApiResponse>(`analytics/focus/${focusId}/timeseries/`, {
      params,
      skipCaseConversion: true,
      signal,
    }),

  getHeatmapSubcategories: (focusId: number, signal?: GenericAbortSignal) =>
    instance.get<HeatmapSubcategoriesResponse>(
      `analytics/focus/${focusId}/heatmap-subcategories/`,
      {
        skipCaseConversion: true,
        signal,
      }
    ),

  getCategoryCountry: (
    focusId: number,
    params: { top_n: number; include_other: boolean; granularity?: string },
    signal?: GenericAbortSignal
  ) =>
    instance.get<CategoryCountryResponse>(`analytics/focus/${focusId}/category-country/`, {
      params,
      skipCaseConversion: true,
      signal,
    }),
});

export const api = makeApi();
